<template>
  <loading-spinner></loading-spinner>
</template>
<script>
import store from '@/store';
import { mapState } from 'vuex';
import Api from '@/store/jsonapi.js';
import config from '@/config';
import _ from 'lodash';

export default {
  props: ['customer_id'],
  data: function () {
    return {
      customer: null
    };
  },
  computed: {
    ...mapState(['currentTenant'])
  },

  methods: {
    impersonate(tenant, token, refresh_token, redirect_url) {
      //Check if we have 2 subdomains in the redirect url, and if there is use the latter
      let checkExperimentalFE = redirect_url.split('.')[2] ? redirect_url.split('.')[1] : false,
        experimental = '';

      // If the 2nd subdomain is "exp" (coming from experimental frontend environment), mix that back into the href after login
      if (checkExperimentalFE === 'exp') {
        experimental = '.' + checkExperimentalFE;
      }

      window.location.href =
        config.frontend.protocol +
        tenant +
        experimental +
        config.frontend.domain +
        '/oauth/impersonate?access_token=' +
        token +
        '&refresh_token=' +
        refresh_token +
        '&redirect_url=' +
        redirect_url;
    },
    async init() {
      if (!this.can('write_customer_tokens')) {
        return;
      }

      let customer_id = +this.customer_id;

      let tenant_name = null;

      if (!_.isNaN(customer_id)) {
        let { data: customer } = await Api.find('customers', this.customer_id, {
          fields: { customers: 'id,tenant_name' }
        });
        tenant_name = customer.tenant_name;
      } else {
        tenant_name = this.customer_id;
      }

      let { data: token } = await Api.create('customer_tokens', {
        tenant: tenant_name
      });

      this.impersonate(tenant_name, token.token, token.refresh_token, this.$route.query.redirect_url);
    }
  },
  mounted: async function () {
    await this.init();
  },
  store
};
</script>

<style scoped></style>
